// FLAGS: none
// One card per local day of "Spaces Schedules" sessions, each row with its sign-up or withdraw action.
import { format, parseISO } from "date-fns";
import { ResponseConveneHostableSessionResponse } from "@src/api/v1/data-contracts";
import { DateFnslocaleMapper } from "@src/DateLocaleSetup";
import HostSignupRow from "@src/views/HostSignups/HostSignupRow";
import { groupByDay } from "@src/views/HostSignups/hostWeeks";

interface HostSignupDaysProps {
  sessions: ResponseConveneHostableSessionResponse[];
  busy: boolean;
  typeLabel?: string;
  onSignUp: (sessionId: string) => void;
  onWithdraw: (sessionId: string) => void;
}

const HostSignupDays = ({
  sessions,
  busy,
  typeLabel = undefined,
  onSignUp,
  onWithdraw,
}: HostSignupDaysProps) => (
  <>
    {groupByDay(sessions).map(([day, daySessions]) => (
      <section
        key={day}
        className="mt-3 rounded-lg bg-white p-4 shadow-sm"
        data-testid="host-signup-day"
      >
        <h3 className="mb-2 text-sm font-semibold uppercase tracking-wide text-slate-700">
          {format(parseISO(day), "EEE d MMM", {
            locale: DateFnslocaleMapper(),
          })}
        </h3>
        <ul className="divide-y divide-slate-100">
          {daySessions.map((session) => (
            <HostSignupRow
              key={session.sessionId}
              session={session}
              busy={busy}
              typeLabel={typeLabel}
              onSignUp={() => onSignUp(session.sessionId)}
              onWithdraw={() => onWithdraw(session.sessionId)}
            />
          ))}
        </ul>
      </section>
    ))}
  </>
);

export default HostSignupDays;
